/**
 * @type utils
 * @name types
 */
/** 解决defaultProps不能被TS识别类型的问题 */
export function createPropsGetter() {
    return function (props) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return props;
    };
}
export function componentWrapper(Component, extra) {
    var Comp = Component;
    Object.keys(extra).forEach(function (key) {
        Comp[key] = extra[key];
    });
    return Comp;
}
